import { GeneralDocumentationData } from './GeneralDocumentationData'
import { FileInfo } from './FileInfo'

export class ReviewedDocumentation {
  private _generalDocumentationData: GeneralDocumentationData
  private _documents: FileInfo[]

  constructor (generalDocumentationData: GeneralDocumentationData, documents?: FileInfo[]) {
    this._generalDocumentationData = generalDocumentationData
    this._documents = documents || []
  }

  procedureCode (): string {
    return this._generalDocumentationData.procedureCode()
  }

  procedureId (): number {
    return this._generalDocumentationData.procedureId()
  }

  madeiristaId (): number {
    return this._generalDocumentationData.madeiristaId()
  }

  batchId (): number {
    return this._generalDocumentationData.batchId()
  }

  documents (): FileInfo[] {
    return this._documents
  }
}
